import React from 'react';
import PropTypes from 'prop-types'
import {Box, Flex, Text} from "rebass";
import {minWidth} from "styled-system";
import styled from 'styled-components'

import {InlineBlock, Input, Popover} from "reakit";

import IosArrowDown from "react-ionicons/lib/IosArrowDown";
import IosArrowUp from 'react-ionicons/lib/IosArrowUp'
import moment from 'moment'

const HeaderTitle = styled(Flex)`
	${minWidth}
`

const DatepickerDropdown = (props) => {
	const {filterTitle, handleSelect, filterType, titleWidth} = props;

	const handleChangeDate = (e) => {
		const value = e.target.value
		console.log(value)
		let timeStamp = moment(value).unix();

		// if clearing date input, set to null for the filter
		if(value === ''){
			timeStamp = null
		}

		handleSelect(timeStamp, filterType)
	}

	return (
		<Popover.Container>
			{popover => (
				<InlineBlock relative>
					<HeaderTitle onClick={popover.toggle} minWidth={titleWidth} flexDirection={'row'}>
						<Box><Text fontWeight={700} color={'black'} >{filterTitle}</Text></Box>
						<Box p={1}>
							{popover.visible ? <IosArrowUp  {...popover}/> :
								<IosArrowDown {...popover} />}

						</Box>
					</HeaderTitle>

					<Popover fade slide expand hideOnClickOutside {...popover} padding={0} margin={0} borderRadius={0} minWidth={'300px'}>
						<Input type={'date'} name={filterType} onChange={handleChangeDate}/>
					</Popover>
				</InlineBlock>
			)}
		</Popover.Container>

	);
};

DatepickerDropdown.propTypes = {
	filterTitle: PropTypes.string,
	filterType: PropTypes.string,
	handleSelect: PropTypes.func,
	selected: PropTypes.array,
	titleWidth: PropTypes.string
};

DatepickerDropdown.defaultProps = {
	filterTitle: "Leaves Filter",
	filterType: 'type',
	options: [],
	selected: [],
	handleSelect: (value, type) => console.log(value, type),
	titleWidth: 'initial'
};

export default DatepickerDropdown;
